export default "__VITE_ASSET__BhHAGxl4__"